var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2894 7.66618L10.6107 9.61702L8.31277 10.1786L8.32824 13.0516L1.36754 8.39994C0.851303 8.0545 0.711426 7.35322 1.05671 6.83657L4.65671 1.4496C5.00174 0.933226 5.7033 0.793349 6.21994 1.13904L11.5246 4.68382L11.4825 7.21507L10.2894 7.66618ZM5.63328 2.01772C5.60086 1.99601 5.55649 2.00497 5.53492 2.03739L3.66633 4.8334L2.59042 6.44297L1.93499 7.42388C1.91409 7.45617 1.92237 7.50012 1.95507 7.52197L7.26123 11.0683L7.25323 9.55883L9.38152 8.65186L9.10651 6.98444L10.4384 6.48054L10.4586 5.24171L5.63328 2.01772Z",
    fill: "#D32029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8535 1.83305L19.0879 7.91398L19.0881 7.91391C19.3022 8.49783 19.0018 9.14649 18.4184 9.36099L15.412 10.4654L12.9687 8.70486L13.9307 6.62513L12.1907 5.8472L12.5672 4.43009L10.5234 2.95775L15.4064 1.1639C15.99 0.949668 16.6386 1.24979 16.8535 1.83305ZM13.7742 3.9975L13.4422 5.24977L15.1843 6.02894L14.3494 8.39804L15.5744 9.28031L18.0536 8.36929C18.0908 8.35613 18.1095 8.31543 18.0959 8.27839L17.6892 7.17088L17.0215 5.35396L15.8619 2.19766C15.8481 2.1609 15.8075 2.14231 15.7709 2.15547L12.7551 3.26378L13.7742 3.9975Z",
    fill: "#D32029"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenOutlined);
export default __webpack_public_path__ + "static/media/broken-outlined.de5bdde2a1fadf3b0d60d49ea43e28cc.svg";
export { ForwardRef as ReactComponent };